import { render, staticRenderFns } from "./2.vue?vue&type=template&id=22b05840&scoped=true"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=22b05840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b05840",
  null
  
)

export default component.exports